import { SelectHTMLAttributes } from 'react';

type Option = {
  value?: string | number;
  label?: string | number;
  disabled?: boolean;
};

export enum LabelPositions {
  TOP = 'Top',
  LEFT = 'Left',
}

export enum SelectPosition {
  LEFT = 'Left',
  RIGHT = 'Right',
}

export interface ISelect extends SelectHTMLAttributes<HTMLSelectElement> {
  options: Option[];
  label?: string;
  classes?: { root?: string; select?: string };
  hasError?: boolean;
  customBackground?: boolean;
  labelPosition?: LabelPositions;
  hideLabel?: boolean;
  selectPosition?: SelectPosition;
}
